import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetTemplateItemsDocument,
  GetTemplateItemsQueryVariables,
  TemplateItemDataFragment,
  TemplateStatus as TemplateItemStatus,
  TemplateStatus,
} from '../../types/api/graphql';

const getStatuses = (statuses: (TemplateStatus | 'ALL')[]) => {
  if (statuses.includes('ALL')) {
    return [
      TemplateItemStatus.Active,
      TemplateItemStatus.Unresolved,
      TemplateItemStatus.Deleted,
    ];
  }

  return statuses as unknown as TemplateItemStatus[];
};

export function useTemplateItems(
  variables: Omit<GetTemplateItemsQueryVariables, 'statuses'> & {
    statuses?: (TemplateStatus | 'ALL')[];
  },
  skip?: boolean
) {
  const { data: templateItemsData, loading: templateItemsLoading } =
    useCacheQuery(GetTemplateItemsDocument, {
      variables: {
        ...variables,
        statuses: getStatuses(variables.statuses ?? [TemplateStatus.Active]),
      },
      skip: skip === true || !variables.healthProviderId,
    });

  // Subscriptions

  const data = useMemo(() => {
    if (templateItemsData?.templates) {
      return {
        ...templateItemsData.templates,
        items: (templateItemsData.templates.items ?? []).map(
          option => option as TemplateItemDataFragment
        ),
      };
    }

    return null;
  }, [templateItemsData?.templates]);

  return {
    data,
    loading: templateItemsLoading,
  };
}
